import {Component, Inject} from '@angular/core';
import {BaseHeaderComponent} from '../shared/base-header.component';
import {AuthService} from '../../../auth/services/auth.service';
import {SidenavService} from '../sidenav/sidenav.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {ProfileService} from '../../../shared/services/profile.service';
import {ParticipantClient} from '../../../shared/apis/api.client';
import {TourService} from '../../../shared/services/tour.service';
import {BreakpointService} from '../../../shared/services/breakpoint.service';
import {AppConstants} from '../../../shared/constants';
import {ENV_CONFIG, EnvConfig} from '../../../../configuration';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseHeaderComponent {
  public supportEmail = '';

  constructor(
    authService: AuthService,
    route: ActivatedRoute,
    breakpointService: BreakpointService,
    router: Router,
    participantClient: ParticipantClient,
    sidenavService: SidenavService,
    tourService: TourService,
    dialog: MatDialog,
    profileService: ProfileService,
    @Inject(ENV_CONFIG) private readonly envConfig: EnvConfig
  ) {
    super(
      authService,
      route,
      breakpointService,
      router,
      participantClient,
      sidenavService,
      tourService,
      dialog,
      profileService
    );
    this.supportEmail = this.envConfig.appConfig.contactInfo?.infoEmail || AppConstants.SupportEmailAddress;
  }

  public contactSupport(): void {
    const mailtoLink = `mailto:${this.supportEmail}`;
    window.location.href = mailtoLink;
  }

}
